import { Chip as MuiChip, SxProps } from '@mui/material';

interface ChipProps {
  label: string | React.ReactElement;
  id?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void;
  onDelete?: () => void;
  deleteIcon?: React.ReactElement;
  /** @default 'filled' */
  variant?: 'filled' | 'outlined' | 'filledBorder';
  /** @default 'primary' */
  color?: 'primary' | 'secondary';
  sxProps?: SxProps;
  disabled?: boolean;
}

export const Chip = ({
  label,
  id,
  onClick,
  variant = 'filled',
  onDelete,
  deleteIcon,
  color = 'primary',
  sxProps,
  disabled,
}: ChipProps) => (
  <MuiChip
    aria-labelledby={id}
    label={typeof label === 'string' ? <span id={id}>{label}</span> : label}
    onClick={onClick}
    variant={variant}
    onDelete={onDelete}
    deleteIcon={deleteIcon}
    size='small'
    color={color}
    sx={sxProps}
    disabled={disabled}
  />
);
